import { Component, Inject, OnInit, inject } from '@angular/core';
import { MainService } from '../../service/main.service';
import { ApiUrls } from '../../apiRouts';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatListModule } from '@angular/material/list';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { ToasterAlert } from '../../shared/toaster.component';
import { ToasterErrAlert } from '../../shared/toaster-err.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { ConfirmDialog } from '../../shared/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { LocalStorageService } from '../../service/local-storage.service';

@Component({
  selector: 'app-city-list',
  templateUrl: './city-list.component.html',
  styleUrl: './city-list.component.scss'
})
export class CityListComponent implements OnInit {
  panelClass: string = '';
  toast: any;
  submitted = false;
  cityList: any = [];
  buttonclick = false;
  cityId: any;
  mainCityDataList :any;
  sub2 = new Subscription;
  _form: any = FormGroup;
  userTypeId: any;
  constructor(
    private mainService: MainService, private _bottomSheet: MatBottomSheet,public dialog: MatDialog,
    private _snackBar: MatSnackBar, private fb: FormBuilder,private localStorageService : LocalStorageService) {
      this.userTypeId = JSON.parse(this.localStorageService.getItem("loginData") || '{}').user_type_id;
    this._form = this.fb.group({
      city_id: ['', [Validators.required]],
    })
    this.sub2 = this.mainService.sendFilterData().subscribe(res => {
      this.cityList = this.mainCityDataList.filter((user: any) => {
        return user.country_name.includes(res.country_name)
      });      
    })
  }

  openBottomSheet(): void {
    this._bottomSheet.open(FilterForm);
  }

  ngOnInit() {
    this.getCity();
  }

  openDialog(e: any, data: any): void {            
    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {
        page: 'deletecity'
      },
    });
    dialogRef.afterClosed().subscribe(result => {               
      if (result == 1) {
        this.deleteCity(data);                
      } else {
        e.source.checked = !e.checked;
        data.status = e.checked == true ? 0 : 1;
      }
    });
  }

  getCity() {
    this.mainService.getApi(ApiUrls.cityList).subscribe((res: any) => {
      if (res.status == 1) {
        this.mainCityDataList = res.city.map((item: any) => ({
          ...item,
          is_active: +item.is_active
        }));
        this.cityList = res.city.map((item: any) => ({
          ...item,
          is_active: +item.is_active
        }));
      }
    });
  }

  searchCity(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    if (!filterValue) {
      this.cityList = this.mainCityDataList
      return;
    }
    this.cityList = this.mainCityDataList.filter((user: any) => {
      return user.city_name.toLowerCase().includes(filterValue)
    });
  }

  deleteCity(data: any) {
    let obj = {
      city_id: Number(data.city_id),
      city_name: "",
      country_name: "",
      Action: 'DELETE',
    };
    this.mainService.postApi(ApiUrls.addCity, obj, 1).subscribe((res: any) => {
      if (res.status == 1) {
        this.getCity();
      }
    });
  }
}

@Component({
  selector: 'filter-form',
  templateUrl: 'filter-form.component.html',
  standalone: true,
  imports: [MatListModule, CommonModule, SharedModule],
})
export class FilterForm {
  filter_cityForm: FormGroup;
  constructor(private _bottomSheetRef: MatBottomSheetRef<FilterForm>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private mainService: MainService, private fb: FormBuilder) {
    this.filter_cityForm = this.fb.group({
      country_name: ['']

    })
  }
  submit() {
    let data = {
      country_name: this.filter_cityForm.value.country_name,
    }
    this.mainService.getFilterData(data);

     this._bottomSheetRef.dismiss();
  }
 cancel(){
  this._bottomSheetRef.dismiss();
  
 }

  openLink(event: MouseEvent): void {
     this._bottomSheetRef.dismiss();
     event.preventDefault();
  }
}

